"use client"

import React from "react"
import { cn } from "../lib/utils"
import { X, Clock } from "./icons"

// Mock UI components
const Button = ({ children, className, onClick, variant, size, ...props }: any) => (
  <button
    className={cn(
      "px-4 py-2 rounded font-medium focus:outline-none",
      variant === "ghost" && "bg-transparent hover:bg-zinc-700/50",
      variant === "outline" && "border border-zinc-700 bg-transparent hover:bg-zinc-700/50",
      size === "icon" && "p-2 aspect-square",
      size === "sm" && "text-sm px-3 py-1",
      className,
    )}
    onClick={onClick}
    {...props}
  >
    {children}
  </button>
)

interface RateLimitModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function RateLimitModal({ open, onOpenChange }: RateLimitModalProps) {
  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 backdrop-blur-sm" 
        onClick={() => onOpenChange(false)}
      />
      
      {/* Modal */}
      <div className="relative bg-zinc-800 border border-zinc-700 rounded-lg p-6 max-w-md mx-4 shadow-xl">
        {/* Close button */}
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onOpenChange(false)}
          className="absolute top-4 right-4 text-zinc-400 hover:text-white"
        >
          <X />
        </Button>

        {/* Content */}
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 rounded-full bg-orange-500/20 flex items-center justify-center">
              <Clock className="w-6 h-6 text-orange-500" />
            </div>
          </div>
          
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-white mb-2">
              Chat Limit Reached
            </h3>
            <p className="text-zinc-400 mb-4">
              You've reached your chat limit. Try again later.
            </p>
            <div className="flex justify-end">
              <Button
                onClick={() => onOpenChange(false)}
                className="bg-emerald-600 hover:bg-emerald-700 text-white"
              >
                Got it
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}